import * as React from 'react';
import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import { VehicleValue } from '../Vehicles';

export default class AvailabilityNote extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field) return null;

    const vehicle = this.props.dataItem as VehicleValue;

    if (vehicle.Destination) {
        return (
            <td {...this.props.tdProps} title={vehicle.AvailabilityNote}>
              {vehicle.Destination.Location} by {dayjs.utc(vehicle.Destination.DateTime).tz("America/New_York").format("M/D HH:mm")}
            </td>
        );
    }

    return (
      <td {...this.props.tdProps}>
        {vehicle.AvailabilityNote}
      </td>
    );
  }

  public shouldComponentUpdate(nextProps: GridCustomCellProps) {
    return nextProps.dataItem.Hash !== this.props.dataItem.Hash;
  }
}
